import React from "react"
import { StyleSheet, Text, View } from "react-native"

import { Firebase } from "../../base"
import { colours, fonts } from "../../base/Constants"
import { DropdownSelect } from "../common"
import OrdersHeaderButton from "./OrdersHeaderButton"
import VenueNameBanner from "./VenueNameBanner"

export default function OrdersHeader(props) {
  const tabTitles = !props.isMobile
    ? ["Current", "Completed"]
    : ["Pending", "Accepted", "Completed"]

  function onTabChanged(index) {
    props.onTabChanged(index)
    let tab = tabTitles[index].toLowerCase()
    Firebase.logEvent("tab_" + tab)
  }

  return (
    <View style={styles.main}>
      <VenueNameBanner venue={props.venue} />
      <View
        style={[
          styles.controlsWrap,
          !props.isMobile && !!props.showTabs && styles.controlsWrapWeb,
        ]}
      >
        {!!props.showTabs && (
          <View style={styles.row}>
            {tabTitles.map((title, index) => {
              let selected = index === props.tab
              return (
                <OrdersHeaderButton
                  selected={selected}
                  onChanged={onTabChanged}
                  index={index}
                  key={index}
                  title={title}
                  isMobile={props.isMobile}
                  pendingCount={props.pendingCount}
                />
              )
            })}
          </View>
        )}
        <View
          style={[
            styles.sortWrap,
            !props.isMobile && !!props.showTabs && styles.sortWrapWeb,
            !props.showTabs && styles.sortWrapLeft,
          ]}
        >
          <Text style={styles.sortLabel}>Sort by:</Text>
          <DropdownSelect {...props.sortProps} />
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    backgroundColor: "white",
    alignItems: "center",
  },

  row: {
    flexDirection: "row",
    alignContent: "space-between",
    paddingHorizontal: 20,
  },

  controlsWrap: { alignSelf: "stretch", alignItems: "center" },
  controlsWrapWeb: {
    flexDirection: "row",
    justifyContent: "center",
  },
  sortWrap: {
    backgroundColor: colours.appWhite,
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 8,
    paddingHorizontal: 16,
    alignSelf: "flex-start",
  },
  sortWrapWeb: {
    position: "absolute",
    left: 0,
    paddingBottom: 0,
    alignSelf: "center",
  },
  sortWrapLeft: {
    alignSelf: "flex-start",
    position: "relative",
    paddingTop: 8,
  },
  sortLabel: {
    marginRight: 16,
    fontFamily: fonts.appRegular,
    fontSize: 12,
    color: colours.appBlack,
  },
})
